import { type IMenusService, MenusService } from "./Menus";
import type { IAPI } from "../APIService";
import { ItemsService, type IItemsService } from "./Items";
import { SalesLimitsService, type ISalesLimitsService } from "./SalesLimits";
import { type IModifiersService, ModifiersService } from "./Modifiers";
import { type IModifierSetsService, ModifierSetsService } from "./ModifierSets";
import { CategoriesService, type ICategoriesService } from "./Categories";
import { ContextService, type IContextService } from "./Context";

export interface IOperationsService {
  menus: IMenusService;
  categories: ICategoriesService;
  items: IItemsService;
  salesLimits: ISalesLimitsService;
  modifiers: IModifiersService;
  modifierSets: IModifierSetsService;
  context: IContextService;
}

export class OperationsService implements IOperationsService {
  menus: IMenusService;
  categories: ICategoriesService;
  items: IItemsService;
  salesLimits: ISalesLimitsService;
  modifiers: IModifiersService;
  modifierSets: IModifierSetsService;
  context: IContextService;
  api: IAPI;

  constructor(api) {
    this.api = api;
    this.menus = new MenusService(api);
    this.categories = new CategoriesService(api);
    this.items = new ItemsService(api);
    this.salesLimits = new SalesLimitsService(api);
    this.modifiers = new ModifiersService(api);
    this.modifierSets = new ModifierSetsService(api);
    this.context = new ContextService(api);
  }
}
